import { Component, ViewChild } from '@angular/core';


import { Router } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ProductModel } from 'src/app/pages/ecommerce/products/products.model';
import { CartService } from 'src/app/shared/service/cartService/cart.service';
import { ParameterService } from 'src/app/shared/service/params/param';
@Component({
  selector: 'app-nouvelle-locations',
  templateUrl: './nouvelle-locations.component.html',
  styleUrl: './nouvelle-locations.component.scss'
})
export class NouvelleLocationsComponent {
  totalItems = 0;
  filteredCooperatives: any[] = [];  // Liste des coopératives filtrées
  searchQuery: string = '';  // Valeur de recherche de l'utilisateur
  breadCrumbItems: Array<{}>;
  productList: ProductModel[];
  showMachine: boolean = false;
  cart: any[] = [];
  cartItems: any[] = [];
  itemsDetails: any[] = [];
  cooperativeItems: any[] = [];
  dateDebut:any;
  dateFin:any;
  searcheMachine :any;
  filteredMachines: any[] = [];
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  machineItems :any = [];
  totalQuantity: number = 0; // Quantité totale
  @ViewChild(NgbPopover) popover: NgbPopover;
  cooperative:any;
  visible: boolean = false;
  cartMessage:any
  private cartMessageSubscription: Subscription;

  constructor(
    private router: Router,
    private paramService: ParameterService,
    private cartService: CartService,
    private messageService: MessageService,

  ) {
    this.getMachineBylocation();
    this.cartMessageSubscription = this.cartService.cartMessage$.subscribe(message => {
      this.cartMessage = message;
      this.messageService.add({ severity: 'info', summary: "Ikena Cooperative", detail: this.cartMessage });    this.totalItems = this.cartService.getTotalItems(); // Mise à jour du total

    });

   }
   ngOnDestroy(): void {
    if (this.cartMessageSubscription) {
      this.cartMessageSubscription.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.totalItems = this.cartService.getTotalItems()
  }


  addItemToCart(item: any): void {
    const accessoire_selectionne = item.accessoires_machine.filter(accessoire => accessoire.selected);

    const itemWithAccessories = {
      ...item,
      accessoire_selectionne: accessoire_selectionne,
    };

    // Ajout de l'item dans le panier
    this.cartService.addToCart(itemWithAccessories);

    this.totalItems = this.cartService.getTotalItems();
  }
  showCart(): void {
    this.router.navigate(['/ikena/reservation'])
  }

  getMachineBylocation(){
    this.paramService.getMachine().subscribe(
      (response:any)=>{
        this.machineItems = response.data;
        this.filteredMachines = this.machineItems;
        console.log("this.machineItems",this.machineItems);

      },
      (error:any)=>{
        console.log("une erreur est survenu",error);

      }

    )
  }

  searchByName() {
    if (this.searcheMachine) {
      this.filteredMachines = this.machineItems.filter(machine =>
        machine.nom.toLowerCase().includes(this.searcheMachine.toLowerCase())
      );
    } else {
      this.filteredMachines = this.machineItems;
    }
  }

}
